import { BaseProduct } from 'services/api/entities/catalog/baseProduct/types/internal/baseProduct-models'
import { YupSchema } from 'services/yup/types'
import { mainProductVS } from './mainProduct'
import { standardPricingArrayVS } from './standard-pricing/standardPricingArray'

export const baseProductVS: YupSchema<BaseProduct> = mainProductVS.shape({
  pricing: standardPricingArrayVS.min(1),
})
